export default "__VITE_ASSET__DMu7E7kg__"